import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-w-[240px]" }

import { reactive, watch, computed } from 'vue';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import { ClientMatter } from '@/models/clientMatter';
import { ClientTableFilter } from '@/models/tableFilters';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsFilter',
  props: {
  filters: { type: Object, required: true },
},
  emits: ['apply-filters'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cm: ClientMatter = reactive({
  client: props.filters.client || null,
  matter: null,
});

// Resync if filters.client is replaced from outside (e.g. Clear All swaps in
// a whole new filters object) - cm is a separate local object ClientMatterSearch
// mutates directly, so it wouldn't otherwise notice an external reset.
watch(
  () => props.filters.client,
  (value) => {
    cm.client = value;
  },
);

// Scopes the client list the same way "Show Matters Involving" scopes the
// matters list - picking a client here should only offer clients relevant
// to whichever attorney/role filters are already selected, not every client
// in the company.
const cmQueryFilter = computed<ClientTableFilter>(() => {
  const filter = new ClientTableFilter();
  filter.scopeAccount =
    typeof props.filters.scopeAccount === 'string'
      ? props.filters.scopeAccount
      : props.filters.scopeAccount?.id || '';
  filter.originating = props.filters.originating;
  filter.involved = props.filters.involved;
  filter.primary = props.filters.primary;
  filter.reviewer = props.filters.reviewer;
  filter.archived = !!props.filters.archived;
  return filter;
});

const handleClientChange = () => {
  props.filters.client = cm.client;
  emit('apply-filters');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ClientMatterSearch, {
      cm: cm,
      "query-filter": cmQueryFilter.value,
      "client-only": "",
      "emit-on-any-change": "",
      "data-cy": "matters-client-filter",
      onMatterChange: handleClientChange
    }, null, 8, ["cm", "query-filter"])
  ]))
}
}

})